import { render, staticRenderFns } from "./c_auxiliary_line.vue?vue&type=template&id=0b4aba22&scoped=true"
import script from "./c_auxiliary_line.vue?vue&type=script&lang=js"
export * from "./c_auxiliary_line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4aba22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4aba22')) {
      api.createRecord('0b4aba22', component.options)
    } else {
      api.reload('0b4aba22', component.options)
    }
    module.hot.accept("./c_auxiliary_line.vue?vue&type=template&id=0b4aba22&scoped=true", function () {
      api.rerender('0b4aba22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_auxiliary_line.vue"
export default component.exports